// extracted by mini-css-extract-plugin
var _1 = "ocl8s";
var _2 = "Ud3lz";
var _3 = "CXjdY";
var _4 = "cAVlx";
var _5 = "SyuGV";
var _6 = "K_fSr";
export { _1 as "base", _2 as "error", _3 as "header", _4 as "help", _5 as "message", _6 as "warning" }
